import * as yup from 'yup';

export const schemaMonitorApi = yup.object({
  num_api_integracao_freq_atu: yup.number().min(0).max(300).default(0),
});
